import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useUserDetails } from 'auth/mutations/userHooks';
import isEmpty from 'lodash/isEmpty';
import { Boat } from 'swagger/models';
import boatsetterPaths from 'utils/boatsetterPaths';

export default function useBlwRouteGuard(boat: Boat) {
  const router = useRouter();
  const { userDetails, isAuthenticated } = useUserDetails();

  useEffect(() => {
    const isFirstPage = router.pathname === boatsetterPaths.listBoat;

    if (isEmpty(userDetails)) return;

    // we ignore any redirect on initial page
    if (isFirstPage) return;

    // if boat data is not set
    if (!boat?.id) return;

    // if user is admin allow everything
    if (userDetails && userDetails.is_admin) return;

    // if user is not owner of the boat redirect him to first page
    if (userDetails && boat?.primary_manager?.id !== userDetails.id) {
      router.push(boatsetterPaths.listBoat);
      return;
    }

    // if boat is completed and user is not on finished page, redirect him to initial page
    if (
      userDetails &&
      boat?.state !== 'incomplete' &&
      !router.pathname.includes('finished') &&
      !router.pathname.includes('listing-pending') &&
      !router.pathname.includes('review')
    ) {
      router.push(boatsetterPaths.listBoat);
    }

    // use isAuthenticated instead of user.isAnonymous
  }, [isAuthenticated, router.pathname, userDetails, boat]);
}
